import {NavLink} from "react-router-dom";

const Sidebar = () => {
    return (
        <aside className="main-sidebar sidebar-dark-primary elevation-4">
            <a href="javascript:void(0)" className="brand-link text-center">
                <span className="brand-text font-weight-light">Management Dashboard</span>
            </a>

            <div className="sidebar">
                <nav className="mt-2">
                    <ul className="nav nav-pills nav-sidebar flex-column p-2" data-widget="treeview" role="menu"
                        data-accordion="false">

                        <li className="nav-item menu-open">
                           <NavLink to={'/companies'} className={({ isActive }) => (isActive ? 'nav-link active' : 'nav-link')}>
                         <i className="nav-icon fas fa-building"></i>
                            <p>
                                Companies
                            </p>
                          </NavLink>
                        </li>

                        <li className="nav-item menu-open">
                           <NavLink to={'/products'} className={({ isActive }) => (isActive ? 'nav-link active' : 'nav-link')}>
                         <i className="nav-icon fas fa-shopping-basket"></i>
                            <p>
                                Products
                            </p>
                          </NavLink>
                        </li>

                        <li className="nav-item menu-open">
                            <NavLink to={'/users'} className={({ isActive }) => (isActive ? 'nav-link active' : 'nav-link')}>
                                <i className="nav-icon fas fa-user"></i>
                                <p>
                                    Users
                                </p>
                            </NavLink>
                        </li>

                        <li className="nav-item menu-open">
                            <NavLink to={'/coupons'} className={({ isActive }) => (isActive ? 'nav-link active' : 'nav-link')}>
                                <i className="nav-icon fas fa-tag"></i>
                                <p>
                                    Coupons
                                </p>
                            </NavLink>
                        </li>
                    </ul>
                </nav>
            </div>
        </aside>
    )
}

export default Sidebar;